export default __webpack_public_path__ + "static/goldflowerpendantback-c69adc8125bdbc7157930af74e8e75e7.png";